import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/shared/avatar/component';
import { setT } from 'helpers/translationUtilities';
playersbarSingle.propTypes = {
    player: PropTypes.object,
    onPlayerClick: PropTypes.func,
    visibleCode: PropTypes.bool
};
export default function playersbarSingle(_a) {
    var _b = _a.player, player = _b === void 0 ? {} : _b, _c = _a.onPlayerClick, onPlayerClick = _c === void 0 ? null : _c, _d = _a.visibleCode, visibleCode = _d === void 0 ? false : _d;
    return (React.createElement("div", { className: "playerlisting__single playerlisting__single--fullwidth playerlisting__single--nocheck", onClick: onPlayerClick },
        React.createElement("div", { className: "playerlisting__set" },
            React.createElement("div", { className: "playerlisting__avatar" },
                React.createElement(Avatar, { src: player.thumbnail }))),
        React.createElement("div", { className: "playerlisting__inner" },
            React.createElement("div", { className: "playerlisting__name" },
                player.name,
                visibleCode ? (React.createElement("div", { className: "playerlisting__code" },
                    setT('game_code'),
                    ": ",
                    player.token)) : null))));
}
